import i18n from '@/lang'

const wordsMap = {
  coins: () => {
    return i18n.t('lang.paidCall.coins')
  }
}

export default wordsMap
